/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Modal, Tooltip } from 'antd';

import { CompassOutlined, DeleteOutlined, EditOutlined, FileAddOutlined } from '@ant-design/icons';

const stagesNoConfirmation = [
  3, // 3 = Confirmado
  4, // 4 = Negado
  5, // 5 = Concluido
  14, // 14 = Aguardando Documentação
  15, // 15 = Faturado/Aguardando Documentação
  16, // 16 = Aguardando Faturamento
];

const stagesNoDeny = [
  3, // 3 = Confirmado
  4, // 4 = Negado
  5, // 5 = Concluido
  13, // 13 = Reservado Sem Confirmação
  14, // 14 = Aguardando Documentação
  15, // 15 = Faturado/Aguardando Documentação
  16, // 16 = Aguardando Faturamento
];

const stagesNoContactClient = [
  3, // 3 = Confirmado
  4, // 4 = Negado
  5, // 5 = Concluido
  13, // 13 = Reservado Sem Confirmação
  14, // 14 = Aguardando Documentação
  15, // 15 = Faturado/Aguardando Documentação
  16, // 16 = Aguardando Faturamento
];

const stagesNoDelete = [
  5, // 5 = Concluido
  14, // 14 = Aguardando Documentação
  15, // 15 = Faturado/Aguardando Documentação
  16, // 16 = Aguardando Faturamento
];

const stagesNoEdit = [];

export default function ActionButtonsComponent({
  selectedRowKeys,
  taskList,
  editingIds,
  fieldsPermissions,
  handleActionClick,
  setIsModalDeletingVisible,
  setIsModalAttachFilesVisible,
  setEditingIds,
  handleSubmit,
  formTaskList,
  setIsModalLocationOnMapVisible,
}) {
  // Monta lista com Treinamentos Selecionados
  const selectedTaskList = taskList.filter(({ id }) => selectedRowKeys.includes(id));

  // Regras para Exibir/Esconder os botões
  const showConfirmationBtn = selectedTaskList.every(
    ({ stage }) => !stagesNoConfirmation.includes(stage.id)
  );
  const showDenyBtn = selectedTaskList.every(({ stage }) => !stagesNoDeny.includes(stage.id));
  const showNoContactClientBtn = selectedTaskList.every(
    ({ stage }) => !stagesNoContactClient.includes(stage.id)
  );
  const showDeleteBtn = selectedTaskList.every(({ stage }) => !stagesNoDelete.includes(stage.id));
  const showEditBtn = selectedTaskList.every(({ stage }) => !stagesNoEdit.includes(stage.id));

  const handleCancel = () => {
    if (formTaskList.isFieldsTouched()) {
      Modal.confirm({
        title: 'Confirmar Cancelamento',
        content: 'Tem certeza de que deseja cancelar as alterações?',
        okText: 'Sim',
        okType: 'danger',
        okButtonProps: {
          style: {
            backgroundColor: '#d9534f',
            color: 'white',
            border: 'none',
          },
        },
        cancelText: 'Não',
        onOk() {
          formTaskList.resetFields();
          setEditingIds([]);
        },
      });
    } else {
      formTaskList.resetFields();
      setEditingIds([]);
    }
  };

  return (
    <div style={{ display: 'flex', gap: 8 }}>
      {fieldsPermissions?.ConfirmBtn?.access >= 1 && (
        <Button
          style={{
            backgroundColor: '#5cb85c', // Verde
            color: 'white',
            border: 'none',
            opacity:
              selectedRowKeys.length === 0 || editingIds.length > 0 || !showConfirmationBtn
                ? 0.3
                : 1,
          }}
          onClick={() => {
            if (selectedRowKeys.length > 0 && editingIds.length === 0 && showConfirmationBtn) {
              handleActionClick('confirm');
            }
          }}
        >
          Confirmar
        </Button>
      )}

      {/* Negar */}
      {fieldsPermissions?.DenyBtn?.access >= 1 && (
        <Button
          style={{
            backgroundColor: '#d9534f', // Vermelho
            color: 'white',
            border: 'none',
            opacity:
              selectedRowKeys.length === 0 || editingIds.length > 0 || !showDenyBtn ? 0.3 : 1,
          }}
          onClick={() => {
            if (selectedRowKeys.length > 0 && editingIds.length === 0 && showDenyBtn) {
              handleActionClick('deny');
            }
          }}
        >
          Negar
        </Button>
      )}

      {/* Sem contato com cliente */}
      {fieldsPermissions?.NoClientContactBtn?.access >= 1 && (
        <Button
          style={{
            backgroundColor: '#fff',
            color: '#333',
            border: 'none',
            opacity:
              selectedRowKeys.length === 0 || editingIds.length > 0 || !showNoContactClientBtn
                ? 0.3
                : 1,
          }}
          onClick={() => {
            if (selectedRowKeys.length > 0 && editingIds.length === 0 && showNoContactClientBtn) {
              handleActionClick('noClientContact');
            }
          }}
        >
          Sem contato com cliente
        </Button>
      )}

      {/* Anexar Arquivos */}
      {fieldsPermissions?.AttachFiles?.access >= 1 && (
        <Tooltip title="Anexar Arquivos">
          <Button
            onClick={() => {
              if (selectedRowKeys.length > 0 && editingIds.length === 0 && showEditBtn) {
                setIsModalAttachFilesVisible(true);
              }
            }}
            icon={<FileAddOutlined />}
            disabled={selectedRowKeys.length === 0 || editingIds.length > 0 || !showEditBtn}
          />
        </Tooltip>
      )}

      {/* Selecionar Localização no Mapa */}
      {fieldsPermissions?.MapLocation?.access >= 1 && (
        <Tooltip title="Selecionar Localização no Mapa">
          <Button
            onClick={() => {
              if (selectedRowKeys.length > 0 && editingIds.length === 0) {
                setIsModalLocationOnMapVisible(true);
              }
            }}
            icon={<CompassOutlined />}
            disabled={editingIds.length > 0 || selectedRowKeys.length === 0 || !showEditBtn}
          />
        </Tooltip>
      )}

      {/* Editar */}
      {fieldsPermissions?.EditBtn?.access >= 1 && (
        <Tooltip title="Editar">
          <Button
            onClick={() => {
              if (selectedRowKeys.length > 0 && editingIds.length === 0 && showEditBtn) {
                setEditingIds(selectedRowKeys);
              }
            }}
            icon={<EditOutlined />}
            disabled={selectedRowKeys.length === 0 || editingIds.length > 0 || !showEditBtn}
          />
        </Tooltip>
      )}

      {/* Remover */}
      {fieldsPermissions?.RemoveBtn?.access >= 1 && (
        <Tooltip title="Remover">
          <Button
            onClick={() => {
              if (selectedRowKeys.length > 0 && editingIds.length === 0 && showDeleteBtn) {
                setIsModalDeletingVisible(true);
              }
            }}
            icon={<DeleteOutlined />}
            disabled={selectedRowKeys.length === 0 || editingIds.length > 0 || !showDeleteBtn}
          />
        </Tooltip>
      )}

      {/* Salvar */}
      {editingIds.length > 0 && (
        <Button
          style={{
            backgroundColor: '#5cb85c', // Verde
            color: 'white',
            border: 'none',
          }}
          onClick={handleSubmit}
        >
          Salvar
        </Button>
      )}

      {/* Cancelar */}
      {editingIds.length > 0 && (
        <Button
          style={{ backgroundColor: '#fff', color: '#333', border: 'none' }}
          onClick={handleCancel}
        >
          Cancelar
        </Button>
      )}
    </div>
  );
}
